import { render, staticRenderFns } from "./az-issue.vue?vue&type=template&id=4c543b70&"
import script from "./az-issue.vue?vue&type=script&lang=js&"
export * from "./az-issue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports